import { render, staticRenderFns } from "./accountPage.vue?vue&type=template&id=d5091af2&scoped=true"
import script from "./accountPage.vue?vue&type=script&lang=js"
export * from "./accountPage.vue?vue&type=script&lang=js"
import style0 from "./accountPage.vue?vue&type=style&index=0&id=d5091af2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5091af2",
  null
  
)

export default component.exports